/*
 * File: CustomClientCard.tsx
 * Project: a-a
 * File Created: Friday, 20th December 2024 11:52:22 pm
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Tuesday, 9th December 2025 6:56:14 pm
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2024 Mutual Mobile, Mutual Mobile
 */
import { Box, Chip, Skeleton, Typography, useTheme } from '@mui/material';
import zeplinColor from '../../../theme/Color';
import CustomCard from '../../shared/CustomCard/CustomCard';
import { LightTooltip } from '../../shared/CustomTooltip/CustomTooltip';

type Client = {
  Name: string;
  AccountId: string;
  closedDealAmount: string | null;
  openDealAmount: string | null;
  category: string | null;
  avatar?: string | null;
  source?: string | null;
};

const CustomClientCard = ({ client, loading }: { client: Client; loading: boolean }) => {
  const theme = useTheme();
  return (
    <>
      <CustomCard
        styles={{
          borderRadius: '14px',
          border: `1px solid ${zeplinColor.Neutral5}`,
          '&:hover': {
            // boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
            borderColor: zeplinColor.BasicBlack,
          },
          //   backgroundColor: zeplinColor.Blue1,
          padding: '16px',
          gap: '12px',
          display: 'flex',
          flexDirection: 'column',
          //   justifyContent: 'space-between',
          // width: '217.2px',
          // height: '261px',
          // minWidth: '217.2px',
          // height: 'auto', // Change from fixed height to auto
          // height: '261px', // Add max-height instead
          // minWidth: '260px',
          minWidth: '277px',
          // maxWidth: '217.2px',
          cursor: 'pointer',
          // overflow: 'hidden',
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: '16px' }}>
          {' '}
          {client?.avatar ? (
            <img
              src={client?.avatar}
              alt='client-avatar'
              style={{
                position: 'relative',
                objectFit: 'fill',
                height: '82px',
                borderRadius: '14px 14px 14px 14px',
                border: `1px solid ${zeplinColor.Neutral3}`,
                // zIndex: 2,
                // margin: 'auto',
                // display: 'block',
                width: '82px',
                // padding: '4px',
              }}
            />
          ) : (
            <Box
              sx={{
                backgroundColor:
                  client?.category === 'Talent'
                    ? zeplinColor.Brand1
                    : loading
                    ? zeplinColor.Neutral3
                    : client?.category === 'Athlete'
                    ? zeplinColor.USER_PROFILE_COLOR1
                    : client?.category === 'Business'
                    ? zeplinColor.USER_PROFILE_COLOR2
                    : client?.category === 'Business_Development'
                    ? zeplinColor.USER_PROFILE_COLOR3
                    : zeplinColor.Brand1,
                borderRadius: '14px 14px 14px 14px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                minWidth: '82px',
                maxWidth: '82px',
                height: '82px',

                // boxSizing: 'border-box',
              }}
              // style={{ width: '82px', height: '82px' }}
            >
              <Typography
                variant='display4'
                sx={{
                  color: zeplinColor.Neutral1,
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',

                  // margin: 0,
                  // padding: 0,
                  // height: '116px',
                }}
              >
                {client?.Name?.split(' ').map((val, index) =>
                  index === 0 || index === client?.Name?.split(' ').length - 1 ? val[0] : '',
                )}
              </Typography>
            </Box>
          )}
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: '16px',
              flex: 1,
              overflow: 'hidden',
            }}
          >
            {loading ? (
              <Skeleton
                variant='text'
                sx={{
                  fontSize: theme.typography.body2,
                  flex: 1,
                  // Optionally adjust other styles here
                }}
              />
            ) : (
              <Box
                sx={{
                  width: '100%',
                  maxWidth: '100%',
                  // overflow: 'hidden',
                }}
              >
                <LightTooltip
                  title={
                    <Typography variant='body3' color={zeplinColor.Neutral1}>
                      {client?.Name || 'N/A'}
                    </Typography>
                  }
                  placement='bottom-start'
                  style={{
                    backgroundColor: zeplinColor.BasicBlack,
                    borderRadius: '8px',
                    position: 'relative',
                  }}
                >
                  <Typography
                    variant='body1'
                    sx={{
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      // textOverflow: 'ellipsis',
                      // width: '100%',
                      // display: 'block',
                      // maxWidth: { xs: '200px', xl: '175px' }, // Explicitly set max width to constrain text
                      maxWidth: 'calc(100% - 10px)',
                      textOverflow: 'ellipsis',
                      width: '100%',
                      // display: 'block',
                      boxSizing: 'border-box',
                    }}
                  >
                    {client?.Name || 'N/A'}
                  </Typography>
                </LightTooltip>
              </Box>
            )}
            {loading ? (
              <Skeleton
                variant='text'
                sx={{
                  fontSize: theme.typography.body2,
                  flex: 1,

                  // Optionally adjust other styles here
                }}
              />
            ) : (
              <Box sx={{ display: 'inline-flex', gap: '4px' }}>
                <LightTooltip
                  title={
                    <Typography variant='body3' color={zeplinColor.Neutral1}>
                      {client.source || 'N/A'}
                    </Typography>
                  }
                  placement='bottom-start'
                  style={{
                    backgroundColor: zeplinColor.BasicBlack,
                    borderRadius: '8px',
                    position: 'relative',
                  }}
                >
                  <Chip
                    label={
                      <Typography
                        variant='label1'
                        color={
                          client.source === 'Huddle' ? zeplinColor.BasicBlack : zeplinColor.Neutral1
                        }
                        sx={{
                          // textAlign: 'center',
                          // display: 'flex',
                          // justifyContent: 'center',
                          // alignItems: 'center',
                          textAlign: 'center',
                          display: 'block', // Changed from flex to block for proper ellipsis
                          maxWidth: '100%', // Ensure it takes full width of container
                          whiteSpace: 'nowrap', // Keep text on one line
                          overflow: 'hidden', // Hide overflow
                          textOverflow: 'ellipsis', // Show ellipsis
                        }}
                      >
                        {client.source === 'Huddle' ? 'Huddle' : 'SF'}
                      </Typography>
                    }
                    sx={{
                      // backgroundColor: zeplinColor.BasicBlack,
                      // padding: '5px 12px 5px 12px',
                      // borderRadius: '50px',
                      // // width: '50%',
                      // height: '24px',
                      backgroundColor:
                        client.source === 'Huddle' ? zeplinColor.Brand2 : zeplinColor.Blue,
                      padding: '5px 12px 5px 12px',
                      borderRadius: '50px',
                      height: '24px',
                      maxWidth: '100%', // Allow chip to take full width available
                      '& .MuiChip-label': {
                        // Target the inner label directly
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        display: 'block',
                        maxWidth: '100px', // Adjust this value as needed
                      },
                    }}
                  />
                </LightTooltip>
                <LightTooltip
                  title={
                    <Typography variant='body3' color={zeplinColor.Neutral1}>
                      {client?.category === 'Business_Development'
                        ? client.category
                            .split('_')
                            .map((word) => word[0].toUpperCase())
                            .join('')
                        : client.category || 'NA'}
                    </Typography>
                  }
                  placement='bottom-start'
                  style={{
                    backgroundColor: zeplinColor.BasicBlack,
                    borderRadius: '8px',
                    position: 'relative',
                  }}
                >
                  <Chip
                    label={
                      <Typography
                        variant='label1'
                        color={zeplinColor.Neutral1}
                        sx={{
                          // textAlign: 'center',
                          // display: 'flex',
                          // justifyContent: 'center',
                          // alignItems: 'center',
                          textAlign: 'center',
                          display: 'block', // Changed from flex to block for proper ellipsis
                          maxWidth: '100px', // Ensure it takes full width of container
                          whiteSpace: 'nowrap', // Keep text on one line
                          overflow: 'hidden', // Hide overflow
                          textOverflow: 'ellipsis', // Show ellipsis
                        }}
                      >
                        {client?.category === 'Business_Development'
                          ? client.category
                              .split('_')
                              .map((word) => word[0].toUpperCase())
                              .join('')
                          : client.category || 'NA'}
                      </Typography>
                    }
                    sx={{
                      // backgroundColor: zeplinColor.BasicBlack,
                      // padding: '5px 12px 5px 12px',
                      // borderRadius: '50px',
                      // // width: '50%',
                      // height: '24px',
                      backgroundColor: zeplinColor.BasicBlack,
                      padding: '5px 12px 5px 12px',
                      borderRadius: '50px',
                      height: '24px',
                      maxWidth: '5rem', // Allow chip to take full width available
                      '& .MuiChip-label': {
                        // Target the inner label directly
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        display: 'block',
                        maxWidth: '5rem', // Adjust this value as needed
                      },
                    }}
                  />
                </LightTooltip>
              </Box>
            )}
          </Box>
        </Box>
        <Box sx={{ display: 'flex', gap: '12px' }}>
          <Box
            sx={{
              borderRadius: '8px',
              padding: '8px',
              display: 'flex',
              flexDirection: 'column',
              gap: '8px',
              backgroundColor: zeplinColor.Neutral3,
              flex: 1,
              textAlign: 'center',
            }}
          >
            {loading ? (
              <Skeleton
                variant='text'
                sx={{
                  fontSize: theme.typography.body2,

                  // Optionally adjust other styles here
                }}
              />
            ) : (
              <Typography variant={'body2'}>${client?.openDealAmount || 'N/A'}</Typography>
            )}
            <Typography variant={'label1'} color={zeplinColor.Neutral8}>
              Open Deals
            </Typography>
          </Box>
          <Box
            sx={{
              borderRadius: '8px',
              padding: '8px',
              display: 'flex',
              flexDirection: 'column',
              gap: '8px',
              backgroundColor: zeplinColor.Neutral3,
              flex: 1,
              textAlign: 'center',
            }}
          >
            {loading ? (
              <Skeleton
                variant='text'
                sx={{
                  fontSize: theme.typography.body2,

                  // Optionally adjust other styles here
                }}
              />
            ) : (
              <Typography variant={'body2'}>${client?.closedDealAmount || 'N/A'}</Typography>
            )}
            <Typography variant={'label1'} color={zeplinColor.Neutral8}>
              Close Deals
            </Typography>
          </Box>
        </Box>
      </CustomCard>
    </>
  );
};

export default CustomClientCard;
